<template>
  <div class="w-100 py-4 border-top-color bg-white text-color-0 d-none d-lg-flex" v-if="full">
    <v-container>
      <v-row>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <v-skeleton-loader :loading="storeConfig == null" type="text">
          <h3 class="text-color-1 font-weight-bold mb-3">{{ storeConfig.store_name }}</h3>
          </v-skeleton-loader>
          <v-skeleton-loader :loading="storeConfig == null" type="text, text" class="d-block">
          <p class="line-height-22">
            CNPJ: {{ cnpjFormat(storeConfig.cnpj_store) }}<br>
            Todos os direitos reservados.
          </p>
          <p class="mt-3 line-height-22">
            {{ storeConfig.street }}, {{ storeConfig.number }},<br>
            {{ storeConfig.district }},<br>
            {{ storeConfig.city }}-{{ storeConfig.state }},<br>
            CEP.: {{ storeConfig.zip_code }}
          </p>
          </v-skeleton-loader>
          <v-skeleton-loader :loading="loadingFooter" type="text, text" class="d-block">
            <p class="mt-3 line-height-22" v-if="footer != null">
              <span v-if="footer.phone != '' && footer.phone != null">Telefone: {{ footer.phone }}</span><br>
              <a v-if="footer.whatsapp != '' && footer.whatsapp != null" class="link-menu" :href="'https://api.whatsapp.com/send?phone='+clearPhone(footer.whatsapp)">Whatsapp: {{ footer.whatsapp }}</a>
            </p>
            <p class="mt-3 line-height-22" v-if="footer != null">
              <a class="mt-3 link-menu text-xxsmall" v-if="footer.email != '' && footer.email != null" :href="'mailto:'+footer.email">{{ footer.email }}</a>
            </p>
          </v-skeleton-loader>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-3">INSTITUCIONAL</h3>
          <div class="pb-xl-2 pb-lg-2 pb-md-2 pb-sm-2 pb-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/quemsomos')">
              Quem Somos
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/politicadeprivacidade')">
              Política de Privacidade
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/comocomprar')">
              Como Comprar
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/locaisehorarios')">
              Entrega
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/politicadetroca')">
              Política de Troca
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/institucional/duvidasfrequentes')">
              Dúvidas Frequentes
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" :href="'https://ofertas.mobilesim.com.br/p/'+group+'.html'" target="_blank">
              Termos de Uso
            </a>
          </div>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-3">SERVIÇOS</h3>
          <div class="pb-xl-2 pb-lg-2 pb-md-2 pb-sm-2 pb-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/services/folhetos')">
              Folhetos
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/services/lembretes')">
              Lembretes
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/services/premios')">
              Prêmios e Brindes 
            </a>
          </div>
          <div v-if="checkModules(9) == 9" class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" href="" @click.prevent="$router.push('/services/pontos')">
              Programa de Pontos
            </a>
          </div>
          <div v-if="checkModules(8) == 8" class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" @click="$router.push('/services/carteira')">
              Carteira Digital
            </a>
          </div>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-1">DEPARTAMENTOS</h3>
          <div v-for="t in getCategoriesLimit(5)" v-bind:key="t.id" class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a href="" @click.prevent="$router.push('/feed/'+t.id)" class="link-menu">
              {{ capitalize(t.name) }}
            </a>
          </div>
          <div class="py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
            <a class="link-menu" @click="$router.push('/categories')">
              <b>+ Departamentos</b>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row class="pt-3">
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center pe-10">
          <h3 class="text-color-1 font-weight-bold mb-3">SEGURANÇA</h3>
          <v-img src="@/assets/images/logo-oci.png" alt="Logo AWS"></v-img>
          <v-img src="@/assets/images/siteseal.png" alt="Siteseal GoDaddy" class="mt-2"></v-img>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-3" v-if="loadingFooter == true || getPayments().length > 0">FORMAS DE PAGAMENTO</h3>
          <v-skeleton-loader :loading="loadingFooter" type="button" class="ma-0">
            <Carousel :autoplay="3000" :settings="settings" v-if="getPayments() != null">
              <Slide v-for="page in [0,8,16,24,32,40,48,56].filter(e => e < getPayments().length)"  :key="page">
                <v-row no-gutters>
                  <v-col cols="10">
                    <v-row no-gutters>
                      <v-col cols="3" v-for="pgto in getPayments(page)" :key="pgto.id" class="text-start">
                        <img v-if="pgto.image != '' && pgto.image != null && pgto.image != undefined && pgto.image != 'no-image'" class="pgto-ico" :src="pgto.image">
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </Slide>
            </Carousel>
          </v-skeleton-loader>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-3" v-if="loadingFooter == true || (footer != null && ( (footer.link_facebook != '' && footer.link_facebook != null) || (footer.link_instagram != '' && footer.link_instagram != null) || (footer.whatsapp != '' && footer.whatsapp != null) ))">NOSSAS REDES SOCIAIS</h3>
          <v-skeleton-loader :loading="loadingFooter" type="button" class="ma-0">
            <v-row v-if="footer != null" no-gutters>
              <v-col class="d-flex">
                <a :href="footer.link_facebook" target="_blank" v-if="footer.link_facebook != '' && footer.link_facebook != null">
                  <v-img src="@/assets/images/icone-facebook.png" alt="Ícone Facebook" class="icon-media"></v-img>
                </a>
                <a :href="footer.link_instagram" target="_blank" class="ms-2" v-if="footer.link_instagram != '' && footer.link_instagram != null">
                  <v-img src="@/assets/images/icone-instagram.png" alt="Ícone Instagram" class="icon-media"></v-img>
                </a>
                <a :href="footer.link_twitter" target="_blank" class="ms-2" v-if="footer.link_twitter != '' && footer.link_twitter != null">
                  <v-img src="@/assets/images/icone-x.png" alt="Ícone X" class="icon-media"></v-img>
                </a>
                <a :href="'https://api.whatsapp.com/send?phone='+clearPhone(footer.whatsapp)" target="_blank" class="ms-2" v-if="footer.whatsapp != '' && footer.whatsapp != null">
                  <v-img src="@/assets/images/icone-whatsapp.png" alt="Ícone Whatsapp" class="icon-media"></v-img>
                </a>
              </v-col>
            </v-row>
          </v-skeleton-loader>
        </v-col>
        <v-col class="v-col-12 v-col-lg-3 text-md-left text-center">
          <h3 class="text-color-1 font-weight-bold mb-3" v-if="loadingFooter == true || (footer != null && ( (footer.link_play_store != '' && footer.link_play_store != null) || (footer.link_app_store != '' && footer.link_app_store != null) ))">BAIXE O APP</h3>
          <v-skeleton-loader :loading="loadingFooter" type="button" class="ma-0">
            <v-row class="pe-5" v-if="footer != null">
              <v-col class="v-col-6 v-col-xl-4 px-2" v-if="footer.link_play_store != '' && footer.link_play_store != null">
                <a :href="footer.link_play_store" target="_blank">
                  <v-img src="@/assets/images/android.png" alt="Ícone Android"></v-img>
                </a>
              </v-col>
              <v-col class="v-col-6 v-col-xl-4 px-2" v-if="footer.link_app_store != '' && footer.link_app_store != null">
                <a :href="footer.link_app_store" target="_blank">
                  <v-img src="@/assets/images/ios.png" alt="Ícone iOS"></v-img>
                </a>
              </v-col>
            </v-row>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div class="w-100 py-4 border-top bg-white text-color-0 d-none d-lg-flex">
    <v-container class="text-center text-small">
      <p class="m-4 footer-line-height">
          As imagens dos produtos no site são meramente ilustrativas. Para melhor atender nossos clientes, não vendemos por atacado. Alguns produtos podem trazer riscos à saúde e que têm sua venda restrita a determinado público. Os produtos de peso podem sofrer variação de preço para mais ou para menos. Preços, ofertas e condições exclusivos para internet e válidos durante o dia de hoje, podendo sofrer alterações sem prévia notificação. Proibida a venda de produtos elencados na Lei n.° 8069/90, art. 81, inciso II (ECA), em especial bebidas alcoólicas, para menores de 18 anos. Venda sujeita à disponibilidade de estoque no dia da entrega. No caso de faltar algum produto, este não será entregue e o valor correspondente não será cobrado.
      </p>
    </v-container>
  </div>
  <div class="w-100 py-4 border-top bg-white text-color-0 d-none d-lg-flex">
    <v-container class="text-center text-small">
      <div class="p-4 d-flex align-center justify-center">
          Desenvolvimento
      </div>
      <div class="mt-2 p-4 d-flex align-center justify-center">
        <img src="@/assets/images/mobilesim.png" style="width: 100px" alt="">
      </div>
      <div class="mt-2">
        <small>{{ versionProject }}</small>
      </div>
    </v-container>
  </div>
  <div class="d-flex d-lg-none footer-margin"></div>
  <div class="icons-footer">
    <a class="icon-top d-none d-lg-flex" @click="goTop()" v-if="scrollPosition > 0">
      <v-icon icon="mdi-chevron-up" class="text-color-white" size="x-large"></v-icon>
    </a>
    <a v-if="footer != null && footer.whatsapp != '' && footer.whatsapp != null" class="icon-whats d-none d-lg-flex mt-2" target="_blank" :href="'https://api.whatsapp.com/send?phone='+clearPhone(footer.whatsapp)">
      <Svgs :icon="'whatsapp'" :color="'fill-color-white'" :width="30" :height="30"></Svgs>
    </a>
  </div>
  <DialogCookies></DialogCookies>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Svgs from '@/components/Svgs.vue';
import DialogCookies from '@/components/DialogCookies.vue';
import { capitalize } from '@/store/services/utils.js';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel';
export default {
  name: 'Footer',
  components: {
    Svgs,
    Carousel,
    Slide,
    DialogCookies
  },
  props: {
    full: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      scrollPosition: 0,
      group: import.meta.env.VITE_GROUP,
      versionProject: import.meta.env.VITE_VERSION_PROJECT,
      footer: null,
      isLoaded: false,
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
        wrapAround: true
      },
    }
  },
  computed: {
    ...mapGetters('main', {
      getCategoriesLimit: 'getCategoriesLimit',
      getPayments: 'getPayments',
      checkModules: 'checkModules'
    }),
    ...mapState('main', {
      loadingFooter: 'loadingFooter',
      storeConfig: 'storeConfig'
    }),
  },
  watch: {
    loadingFooter(t) {
      if(t){
        this.isLoaded = false;
      }
    },
  },
  methods: {
    ...mapActions('main', {
      getFooter: 'getFooter'
    }),
    capitalize,
    cnpjFormat(cnpj){
      return cnpj.replaceAll(" ", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    },
    clearPhone(phone){
      return phone.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "");
    },
    onScroll() {
      this.scrollPosition = window.top.scrollY;
      let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) > (document.documentElement.offsetHeight - 1000);
      if (bottomOfWindow && document.documentElement.scrollTop > 0 && this.isLoaded == false) {
        if(this.full == true){
          this.isLoaded = true;
          this.getFooter().then(function(response){
            this.footer = response;
          }.bind(this)).catch(function(){
            this.isLoaded = false;
          }.bind(this));
        }
      }
    },
    goTop(){
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  },
  mounted(){
    window.addEventListener("scroll", this.onScroll);
  },
  unmounted(){
    window.removeEventListener("scroll", this.onScroll);
  }
};
</script>